export const SCANNER_VERSION = 2;
export const CLOCK_SKEW_TOLERANCE_MS = 5 * 60 * 1000;

export const SCANNER_STATES = [
  "Monitoring",
  "Building",
  "Ready to review",
  "Weakening",
  "Risk blocked",
  "Insufficient evidence",
];

export const PRIORITIES = [
  "Critical risk",
  "Ready to review",
  "Developing",
  "Informational",
];

export const RISK_LEVELS = ["Low", "Moderate", "High", "Critical"];
export const EVIDENCE_STATUSES = [
  "simulated",
  "static-demo",
  "system-derived",
  "hypothesis",
  "unavailable",
];
export const FACTOR_STATUSES = [
  "positive",
  "negative",
  "conflicting",
  "unavailable",
];

// Weights total 100. Risk remains a separate readiness gate; extension and
// reward-to-risk are included here only as transparent setup-quality evidence.
export const FACTOR_DEFINITIONS = {
  trendStructure: { label: "Trend structure", weight: 7, critical: true },
  orderFlow: { label: "Order flow", weight: 7, critical: false },
  institutionalActivity: { label: "Institutional activity", weight: 6, critical: false },
  volume: { label: "Volume", weight: 8, critical: true },
  vwap: { label: "VWAP", weight: 8, critical: true },
  macd: { label: "MACD", weight: 7, critical: true },
  relativeVolume: { label: "Relative volume", weight: 6, critical: false },
  levelTwo: { label: "Level II", weight: 5, critical: false },
  timeSales: { label: "Time & Sales", weight: 5, critical: false },
  optionsFlow: { label: "Options flow", weight: 5, critical: false },
  news: { label: "News", weight: 5, critical: false },
  sectorStrength: { label: "Sector strength", weight: 6, critical: false },
  liquidity: { label: "Liquidity", weight: 7, critical: true },
  spread: { label: "Spread", weight: 6, critical: true },
  extensionRisk: { label: "Extension risk", weight: 6, critical: true },
  riskReward: { label: "Reward-to-risk", weight: 6, critical: true },
};

export const SNAPSHOT_KEYS = [
  "schemaVersion",
  "symbol",
  "setup",
  "direction",
  "alertType",
  "riskLevel",
  "riskReward",
  "extensionPercent",
  "stability",
  "lastPrice",
  "previousClose",
  "dollarChange",
  "percentageChange",
  "bid",
  "ask",
  "spread",
  "volume",
  "relativeVolume",
  "dayLow",
  "dayHigh",
  "openPrice",
  "updatedAt",
  "whyMoving",
  "source",
  "evidenceStatus",
  "asOf",
  "demoLabel",
  "factors",
];

export const FACTOR_KEYS = [
  "status",
  "score",
  "explanation",
  "evidenceStatus",
  "source",
];

export const DEMO_NOTICE =
  "Simulated demonstration data — not current market data.";

export const MIN_READY_RISK_REWARD = 2;
export const MAX_READY_EXTENSION = 70;
export const CRITICAL_MISSING_CONFIDENCE_CAP = 69;
export const DUPLICATE_COOLDOWN_MS = 60_000;
export const MATERIAL_SCORE_CHANGE = 8;
export const STATE_HYSTERESIS = 3;

export const TOTAL_FACTOR_WEIGHT = Object.values(FACTOR_DEFINITIONS).reduce(
  (total, factor) => total + factor.weight,
  0
);

